export default {
  completion: '{{percent}}% 完了',
  pagesValidationProgress: '{{valid}}/{{total}} ページが有効（{{percent}}%）',
  pageComplete: '完了',
  copyPath: 'パスをコピー',
  pathCopiedToClipboard: 'パスをクリップボードにコピーしました',
  subPage: 'サブページ',
  addChildTo: '{{nodeDefLabel}}に追加',
  addChildToTitle: '{{nodeDefLabel}}に新しいノードを追加',
  addChildToTypes: {
    boolean: '正誤値',
    code: 'コード',
    coordinate: '座標',
    date: '日付',
    decimal: '小数',
    geo: '地理空間',
    entity: 'テーブルまたはフォーム',
    file: 'ファイル',
    integer: '整数',
    taxon: '分類群',
    text: 'テキスト',
    time: '時刻',
    // layout elments
    formHeader: 'フォームヘッダー',
  },
  clone: `「{{nodeDefLabel}}」を複製`,
  compressFormItems: `「{{nodeDefLabel}}」のフォーム項目を圧縮表示`,
  confirmClearNonApplicableValues: `次の項目は適用対象外となり、その値は消去されます：

{{nodeDefLabels}}

続行しますか？`,
  confirmUpdateDependentEnumeratedEntities: `続行すると、一部の列挙項目（{{entityDefs}}）が再列挙され、
既に入力されている値は削除されます（存在する場合）。
続行しますか？`,
  convert: `「{{nodeDefLabel}}」を変換`,
  delete: `「{{nodeDefLabel}}」を削除`,
  edit: `「{{nodeDefLabel}}」を編集`,
  schemaSummary_csv: 'スキーマ概要（CSV）',
  schemaSummary_xlsx: 'スキーマ概要（Excel）',
  schemaSummaryAiDescriptions_csv: 'スキーマ概要＋AI説明（CSV）',
  schemaSummaryAiDescriptions_xlsx: 'スキーマ概要＋AI説明（Excel）',
  hidePages: 'ページを隠す',
  showPages: 'ページを表示',
  move: `「{{nodeDefLabel}}」を移動`,
  movePageUp: 'ページを上に移動',
  movePageDown: 'ページを下に移動',
  formEditActions: {
    preview: 'プレビュー',
    previewDesktop: 'プレビュー (デスクトップ)',
    previewMobile: 'プレビュー (モバイル)',
    previewOptions: 'プレビューのオプション',
  },
  mobilePreview: {
    device: {
      phone: 'スマートフォン',
      tablet: 'タブレット',
    },
    error: 'モバイルプレビューの読み込み中にエラーが発生しました: {{error}}',
    differences: `**実機の Arena Mobile との違い**
- **日付と時刻**: 端末の日付/時刻ピッカーではなく、テキスト欄に入力します (DD/MM/YYYY、HH:mm)
- **地図**: 利用できません (地図ボタンはプレースホルダーを表示。オフライン地図・PDF 地図なし)
- **位置情報**: ブラウザから取得します (通常は端末の GPS より精度が低い)。外部 GPS 受信機は使用できません
- **写真とファイル**: コンピューターから選択します。カメラでの撮影と写真の位置情報 (EXIF) は利用できません
- **キーボードと操作**: 画面キーボードやスワイプではなく、物理キーボードとマウスを使用します
- **データ**: メモリ上にのみ保持され、再読み込みで失われます。レコード一覧・同期・エクスポートはありません`,
    note: '下書きの調査をブラウザで実行した Arena Mobile の近似表示です。',
    orientation: {
      landscape: '横向き',
      portrait: '縦向き',
    },
    reload: '再読み込み',
    title: 'モバイルプレビュー',
  },
  formEntryActions: {
    confirmDemote: 'この記録を{{name}}に差し戻しますか？',
    confirmPromote: `この記録を**{{name}}に昇格**してもよろしいですか？
これ以降は編集できなくなります`,
    confirmPromoteWithErrors: `**この記録にはエラーがあります**。
$t(surveyForm:formEntryActions.confirmPromote)`,
    confirmDelete: 'この記録を削除しますか？\n\n$t(common.cantUndoWarning)',
    closePreview: 'プレビューを閉じる',
    demoteTo: '{{stepPrev}}に差し戻し',
    promoteTo: '{{stepNext}}に昇格',
    step: 'ステップ{{id}}（{{name}}）',
  },
  nodeDefEditFormActions: {
    columns: '列',
    confirmConvert: '属性「{{name}}」を「{{toType}}」に変換しますか？',
    confirmDelete: 'このノード定義「{{ name }}」を完全に削除しますか？\n\n$t(common.cantUndoWarning)',
  },
  nodeDefCode: {
    code: '$t(common.code)',
    label: '$t(common.label)',
    typeCodeOrLabel: 'コードまたはラベルを入力',
    option: '選択肢{{value}}',
  },
  nodeDefBoolean: {
    labelValue: {
      trueFalse: {
        true: '$t(common.true)',
        false: '$t(common.false)',
      },
      yesNo: {
        true: '$t(common.yes)',
        false: '$t(common.no)',
      },
    },
  },
  nodeDefCoordinate: {
    coordinate: '座標',
    srs: 'SRS',
    x: 'X',
    y: 'Y',
    showOnMap: '地図に表示',
    accuracy: '精度',
    altitude: '標高',
    altitudeAccuracy: '標高精度',
  },
  nodeDefGeo: {
    confirmDelete: 'この地理空間値を削除しますか？',
    geoJSON: 'GeoJSON',
    invalidGeoJsonFileUploaded: 'アップロードされたGeoJSONファイルが無効です',
  },
  nodeDefEntityForm: {
    addNewEntity: '新しい{{name}}を追加',
    confirmDelete: 'この項目を削除しますか？',
    select: '{{name}}を選択：',
    selectedEntity: '選択中の{{name}}：',
  },
  nodeDefTaxon: {
    code: '$t(common.code)',
    scientificName: '学名',
    vernacularName: '通称名',
    vernacularNameAlwaysIncludedIfSingle: '通称名が1件のみの場合は常に含める',
    vernacularNameAlwaysIncludedIfSingleInfo: `- **有効**：このオプションが有効で、分類群に通称名が1件のみ登録されている場合、その分類群が選択されるとその通称名が自動的にデータとともに保存されます。
- **無効**：分類群に通称名が1件のみであっても、分類群コードと学名のみが保存されます。`,
    vernacularNameSelectionKept: '選択した通称名を保持',
    vernacularNameSelectionKeptInfo: `- **有効**：通称名（一般名）を使って分類群を選択した場合、検索に使用した具体的な通称名もデータに保存されます。
- **無効**：検索時にどの通称名を使用したかにかかわらず、分類群コードと学名のみが保存されます。
Arena Mobileでは：
- **有効**：各通称名が検索結果の一覧に個別の項目として表示されます。
- **無効**：同じ分類群のすべての通称名がまとめられ、分類群と一緒に1つの項目として表示されます。そのため、オートコンプリートの項目数が少なくなります。`,
    visibleFields: '表示する項目',
  },
  nodeDefFile: {
    errorLoadingPreview: 'プレビューの読み込み中にエラーが発生しました',
    fileUuid: 'ファイルUUID',
    fileName: 'ファイル名',
    locationInformationNotFound: 'ファイル内に位置情報が見つかりません',
  },
  nodeDefsTreeSelectMode: {
    allNodeDefs: 'すべてのノード',
    onlyPages: 'ページのみ',
  },
  step: {
    entry: '入力',
    cleansing: 'クレンジング',
    analysis: '分析',
  },
  cloneFromAnotherSurvey: {
    title: '別の調査からノードを複製',
    expandToLoadNodes: '展開してノードを読み込む',
    loadingSurveyNodes: '調査のノードを読み込み中...',
    errorLoadingSurveyNodes: '調査のノードの読み込み中にエラーが発生しました',
    noNodesAvailable: '利用可能なノードがありません',
    loadingSurveys: '調査を読み込み中...',
    noSurveysAvailable: '利用可能な調査がありません',
    sourceNode: '複製元ノード',
    targetEntityCurrentSurvey: '複製先項目（現在の調査）',
  },
  confirmNodeDelete: 'この{{nodeDefType}}（{{nodeDefLabel}}）を削除しますか？',
  downloadPrintableDocument: '印刷用ドキュメントをダウンロード（Word）',
  downloadPrintableDocumentPdf: '印刷用ドキュメントをダウンロード（PDF）',
  printableExport: {
    title: '印刷用ドキュメントをエクスポート',
    exportDocument: 'ドキュメントをエクスポート',
    format: '形式',
    formats: {
      pdf: 'PDF',
      docx: 'Word',
    },
    scope: '内容',
    scopes: {
      full: '調査全体',
      currentPage: '現在のページのみ ({{entityLabel}})',
    },
    currentPageUnavailable:
      '現在のページのインスタンスを特定できません。特定のページに移動するか、調査全体をエクスポートしてください。',
    includeQrCode: 'QRコードを含める',
    includeQrCodeInfo:
      '先頭ページに、このエンティティの読み取り専用PDFへリンクするQRコードを追加します（有効期限1年）。',
    orientation: 'ページの向き',
    orientations: {
      portrait: '縦',
      landscape: '横',
    },
    download: 'ダウンロード',
  },
  exportLabels_csv: 'ラベルをエクスポート（CSV）',
  exportLabels_xlsx: 'ラベルをエクスポート（Excel）',
  importLabels: 'ExcelまたはCSVからラベルをインポート',
  aiTranslateLabels: 'AI：ラベルを翻訳',
  nodeDefsTranslation: {
    apply: '翻訳を適用',
    applySuccess: '翻訳を適用しました',
    aiSuggestion: 'AI',
    current: '現在',
    custom: 'カスタム',
    defaultDescription: 'デフォルトの説明',
    defaultLabel: 'デフォルトのラベル',
    path: 'パス',
    showDescriptions: '説明を表示',
    title: 'ノード定義ラベルを翻訳',
  },
}
